module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/198.8bd695ff.png";